import { Check } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const TYPES = [
  "Mobil araç yıkama ekipleri",
  "Oto yıkama işletmeleri",
  "Detailing uzmanları",
  "Bireysel araç bakım hizmeti verenler",
  "Pasta-cila ve seramik kaplama hizmeti veren işletmeler",
];

export const WhoCanApply = () => {
  const loop = [...TYPES, ...TYPES];
  return (
    <section id="kimler" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <Reveal className="lg:col-span-5">
            <SectionLabel>Kimler Katılabilir</SectionLabel>
            <h2 className="mt-5 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-[#172033]">
              Kimler Partner Olabilir?
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-[#667085]">
              İster bireysel çalış ister bir ekibin veya işletmen olsun; yerinde araç bakım ve
              temizlik hizmeti verebiliyorsan YıkaGel'e başvurabilirsin.
            </p>
          </Reveal>

          <Reveal className="lg:col-span-7" delay={0.1}>
            <div className="grid sm:grid-cols-2 gap-4">
              {TYPES.map((t, i) => (
                <div
                  key={i}
                  data-testid={`who-item-${i + 1}`}
                  className="flex items-start gap-3 rounded-2xl border border-gray-100 bg-white p-5 transition-colors hover:border-[#22C7D6]/50"
                >
                  <span className="mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#22C7D6]/15 text-[#0B3B75]">
                    <Check size={16} />
                  </span>
                  <span className="text-[15px] font-medium text-[#172033]">{t}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>

      {/* Editorial marquee ribbon */}
      <div className="mt-20 relative select-none">
        <div className="flex w-max animate-marquee gap-16 whitespace-nowrap opacity-[0.9]">
          {loop.map((t, i) => (
            <span key={i} className="font-heading text-3xl sm:text-5xl font-black tracking-tight text-transparent [-webkit-text-stroke:1px_#CBD8E8]">
              {t} <span className="text-[#22C7D6] [-webkit-text-stroke:0]">•</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
